@if (trainingSchedule) {
  <div class="tile">
    <div class="date-section table-row">
      @if (trainingSchedule.Classes[0]) {
        <div class="table-cell date-cell">
          <div class="left">
            <div class="month-day">{{trainingSchedule.Classes[0].StartDate | utcToLocalDateTime:'MMM'}}</div>
            <div class="day-of-week">{{trainingSchedule.Classes[0].StartDate | utcToLocalDateTime: 'EEE'}}</div>
          </div>
          <div class="right">
            <div class="month-date">{{trainingSchedule.Classes[0].StartDate | utcToLocalDateTime:'dd'}}</div>
          </div>
        </div>
      }
      @if (trainingSchedule.TrainingTypeName === 'eLearning') {
        <div class="table-cell date-cell">
          <div class="left">
            <div class="open">{{'TrainingSchedule.Open' | translate}}</div>
          </div>
        </div>
      }
      <div class="table-cell training-type">
        {{trainingSchedule.TrainingTypeName}}
      </div>
    </div>
    <div class="training-details">
      <div class="table-header">
        <div class="schedule-name">{{currentLang == 'en' || trainingSchedule.NameFr == '' ||
          trainingSchedule.NameFr == null ?
        trainingSchedule.Name : trainingSchedule.NameFr}}</div>
        <hr class="inset">
        <div class="instructor-name">{{trainingSchedule.TrainingProviderName}}</div>
      </div>
      <div class="table-row address-row">
        <div class="table-cell address-cell table-cell-padding ontario-small-6">
          <div class="details-cell">
            <label aria-label="address" for="address">{{'TrainingSchedule.TrainingLocation' | translate}}</label>
            @if (trainingSchedule.TrainingTypeName !== 'eLearning') {
              <p class="address" class="address-info">{{trainingSchedule.AddressLine}},
                {{trainingSchedule.CityTown}},
              {{trainingSchedule.Province}}, {{trainingSchedule.PostalCode}}</p>
            }
            @if (trainingSchedule.TrainingTypeName === 'eLearning') {
              <p class="address" class="address-info">{{'TrainingSchedule.SelfpacedOnline' | translate}}</p>
            }
          </div>
        </div>
        <div class="table-cell table-cell-padding ontario-small-6">
          <div class="details-cell">
            <label for="classInfo" class="class-info-label">{{'TrainingSchedule.ClassInformation' |
            translate}}</label>
            @for (class of trainingSchedule.Classes; track class) {
              <p class="class-info">
                {{class.StartDate | utcToLocalDateTime:'MMM d'}} -
                {{class.StartDate | utcToLocalDateTime: 'EEE'}} &#64; {{class.StartDate | utcToLocalDateTime:'shortTime'}}
              {{'TrainingSchedule.to' | translate}} {{class.EndDate | utcToLocalDateTime:'shortTime'}}</p>
            }
            @if (trainingSchedule.TrainingTypeName === 'eLearning') {
              <p class="class-info"
                [innerHTML]="'TrainingSchedule.SelfpacedProgramReqs' | translate">
              </p>
            }
          </div>
        </div>
      </div>
      <div class="action-row">
        <!-- <button class="enrol-button">{{'TrainingSchedule.Enrol' | translate}}</button> -->
      </div>
      <div class="table-row tile-bottom-section">
        <div class="table-cell table-cell-padding  ontario-small-6">
          <label aria-label="seats available" for="seats-avail">{{'TrainingSchedule.SeatsAvailable' | translate}}</label>
          <span class="seats-avail">{{trainingSchedule.TrainingTypeName !== 'eLearning' ? seatsAvailable+'/'+trainingSchedule.Capacity : 'TrainingSchedule.Available' | translate}}</span>
        </div>
        <div class="table-cell table-cell-padding ontario-small-6 course-fee">
          <div class="vertical-hr"></div>
          <label aria-label="fee cost" for="fee-cost">{{'TrainingSchedule.CourseFee' | translate}}</label>
          <span class="fee-cost">{{trainingSchedule.Cost != null ? (trainingSchedule.Cost | currency) :
          ('TrainingSchedule.ContactUs' | translate)}}</span>
        </div>
      </div>
    </div>
  </div>
}

@if (trainingSchedule) {
  <div class="mobile-tile ontario-row" >
    <div class="ontario-column ontario-small-12 card">
      <div class="date-section">
        <div class="trainingtype">{{trainingSchedule.TrainingTypeName}}</div>
        @if (trainingSchedule.Classes[0]) {
          <div class="date">
            <div class="month-day">{{trainingSchedule.Classes[0].StartDate| utcToLocalDateTime:'MMMM'}}</div>
            <div class="day">{{trainingSchedule.Classes[0].StartDate | utcToLocalDateTime: 'dd'}}</div>
            <div class="day-of-week">{{trainingSchedule.Classes[0].StartDate | utcToLocalDateTime: 'EEEE'}}</div>
          </div>
        }
        @if (trainingSchedule.TrainingTypeName === 'eLearning') {
          <div class="date">
            <div class="open">{{'TrainingSchedule.Open' | translate}}</div>
          </div>
        }
      </div>
      <div class="seats-section">
        <div class="seats">
          <label class="seats-available" for="seat-fraction">{{"Marketplace.SeatsAvailable" | translate}}</label>
          <span class="seat-fraction">
            {{trainingSchedule.TrainingTypeName !== 'eLearning' ? seatsAvailable+'/'+trainingSchedule.Capacity : 'TrainingSchedule.Available' | translate}}
          </span>
          <div class="mini-hr"></div>
          <label class="course-fee">{{"Marketplace.CourseFee" | translate}}</label>
          <span class="course-fee-amount">{{trainingSchedule.Cost == null ? 'N/A' : trainingSchedule.Cost | currency}}</span>
        </div>
      </div>
    </div>
    <div class="ontario-column ontario-small-12 program-type-location">
      <div class="schedule-name ">{{currentLang == 'en' || trainingSchedule.NameFr == '' ||
        trainingSchedule.NameFr == null ?
        trainingSchedule.Name : trainingSchedule.NameFr}}
      </div>
      <div class="border-top"></div>
      <div class="training-location">
        {{trainingSchedule.CityTown}}
      </div>
      @if (viewDetails) {
        <div class="border-top"></div>
        <div class="card-row ">
          <label aria-label="Provider name" for="type">{{'TrainingSchedule.ProvidedBy' | translate}}</label>
          <span>{{trainingSchedule.TrainingProviderName}}</span>
        </div>
        <div class="card-row">
          <label for="classInfo" class="class-info-label">{{'TrainingSchedule.ClassInformation' |
          translate}}</label>
          @for (class of trainingSchedule.Classes; track class) {
            <span class="class-info">
              {{class.StartDate | utcToLocalDateTime:'MMM d'}} -
              {{class.StartDate | utcToLocalDateTime: 'EEE'}} &#64; {{class.StartDate | utcToLocalDateTime:'shortTime'}}
            {{'TrainingSchedule.to' | translate}} {{class.EndDate | utcToLocalDateTime:'shortTime'}}</span>
          }
          @if (trainingSchedule.TrainingTypeName === 'eLearning') {
            <span class="class-info"
              [innerHTML]="'TrainingSchedule.SelfpacedProgramReqs' | translate">
            </span>
          }
        </div>
        <div class="card-row">
          <label aria-label="address" for="address">{{'TrainingSchedule.TrainingLocation' | translate}}</label>
          @if (trainingSchedule.TrainingTypeName !== 'eLearning') {
            <span class="address" class="address-info">
              <div>{{trainingSchedule.AddressLine}}</div>
              <div>{{trainingSchedule.CityTown}} - {{trainingSchedule.Province}} {{trainingSchedule.PostalCode}}</div>
            </span>
          }
          @if (trainingSchedule.TrainingTypeName === 'eLearning') {
            <span class="address" class="address-info">{{'TrainingSchedule.SelfpacedOnline' | translate}}</span>
          }
        </div>
        <div class="card-row">
          <label for="type">{{'General.Contact' | translate}}</label>
          @for (elecAddress of trainingSchedule.ElectronicAddresses; track elecAddress) {
            <span >
              @if (elecAddress.TypeName == 'Website') {
                <div class="contact-word-break">{{elecAddress.TypeName[0]}}: @if (elecAddress.TypeName == 'Website') {
                  <a target="_blank" [href]="elecAddress.ElectronicAddressValue">{{elecAddress.ElectronicAddressValue}}</a>
                }</div>
              }
              @if (elecAddress.TypeName == 'Phone') {
                <div class="contact-word-break">{{elecAddress.TypeName[0]}}: {{elecAddress.ElectronicAddressValue | phone}}</div>
              }
              @if (elecAddress.TypeName == 'Email') {
                <div class="contact-word-break">{{elecAddress.TypeName[0]}}: {{elecAddress.ElectronicAddressValue}}</div>
              }
            </span>
          }
        </div>
        <div>
          <button class="enroll-button float-left" (click)="NavigateToEnrol()">
            <div>{{'TrainingSchedules.Enrol' | translate}}</div>
          </button>
        </div>
      }
    </div>
    <div class="ontario-column ontario-small-12 " [ngClass]="{'view-footer':!viewDetails,'hide-footer':viewDetails}" (click)="viewDetails = !viewDetails">
      {{ viewDetails == false ?  ('Worker.ShowDetails' | translate) : ('Worker.HideDetails' | translate)  }}
    </div>
  </div>
}